import {CPSConstants} from "commonUtils/enumerations";

export const formTextFieldStyle = {
  loginmuiTextFieldStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& .MuiInputLabel-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      color: "#242A3C",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      color: "#242A3C",
    },
    "& ::placeholder": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontSize: CPSConstants.FONTREMTEXT,
    },
    "& .MuiInputBase-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      height: "3rem",
    },
    "& .MuiOutlinedInput-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      "& fieldset": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        borderColor: "#b3bfe2",
      },
      "&:hover fieldset": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        borderColor: "#b3bfe2",
      },
    },
    "& .MuiFormHelperText-root.Mui-error": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      margin: 0,
      position: "relative",
      width: "100%",
      paddingTop: "0.5rem",
      fontSize: CPSConstants.FONTREMTEXT,
      color: "red",
      fontWeight: CPSConstants.FONTWEIGHT,
      textAlign: "left",
    },
    "& .MuiInputBase-root.Mui-disabled": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#f0f0f0",
    },
    "& .MuiInputBase-input.Mui-disabled": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      WebkitTextFillColor: "#003",
    },
  },
  txtFieldBoxContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "column",
    minWidth: "300px",
  },
};
